const createStartingBalance = (startingDate, startingBalance) => {
  const formatStartDate = new Date(startingDate);

  formatStartDate.setUTCDate(1);
  formatStartDate.setUTCHours(23, 59, 0, 0);

  return startingBalance.map((value, index) => {
    const monthDate = new Date(formatStartDate.getTime());
    monthDate.setUTCMonth(monthDate.getUTCMonth() + index);

    return {
      month: monthDate.getTime(),
      value: value,
    };
  });
};

export default createStartingBalance;
